/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add a new user to the organization with an email invitation." |
*
* @param {Members_Add_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_dialog_description = /** @type {((inputs?: Members_Add_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge einen neuen Benutzer zur Organisation mit einer E-Mail-Einladung hinzu.")
	return /** @type {LocalizedString} */ ("Add a new user to the organization with an email invitation.")
});